// @mui
import PropTypes from 'prop-types';
import { Box, Card, Paper, Typography, CardHeader, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import { fShortenNumber } from '../../utils/formatNumber';
import { MAIN_PATH } from '../../constants';
import Iconify from '../../components/iconify';

Tile.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  list: PropTypes.array.isRequired,
};

export function Tile({ title, subheader, list, ...other }) {
  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: 'repeat(2, 1fr)',
          }}
        >
          {list.map((site) => (
            <Paper
              key={site.name}
              variant="outlined"
              sx={{ py: 2.5, textAlign: 'center' }}
              component={Link}
              to={`/admin/${MAIN_PATH}/${site.path}`}
            >
              <Box sx={{ mb: 0.5 }}>{site.icon}</Box>

              {site.loading ? (
                <Iconify icon={'line-md:loading-twotone-loop'} color="#006097" width={32} />
              ) : (
                <Typography variant="h6">{fShortenNumber(site.value)}</Typography>
              )}
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {site.name}
              </Typography>
            </Paper>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
